export default __webpack_public_path__ + "static/media/logo-dark.53542e77.svg";